import TailwindThemeProvider from "../TailwindThemeProvider";

const DarkThemeProvider: FC = ({ children }) => (
  <TailwindThemeProvider colorScheme="dark">{children}</TailwindThemeProvider>
);

export default DarkThemeProvider;
